import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { safeReturnUrl } from '../routes/safe-return-url';
import { AuthService } from '../../core/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(
    private authService: AuthService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authService.getAccessToken()) {
      return true;
    }

    const returnUrl = safeReturnUrl(state.url);
    if (returnUrl) window.sessionStorage.setItem('returnUrl', returnUrl);
    else window.sessionStorage.removeItem('returnUrl');
    this.authService.signIn();
    return false;
  }
}
